import React, { useState } from 'react';
import axios from 'axios';

const PayUButton = () => {
  const [paymentData, setPaymentData] = useState(null);

  const payNow = async () => {
    const txnid = "txn_" + Date.now();
    const amount = "500.00";
    const key = "YOUR_MERCHANT_KEY";
    const salt = "YOUR_SALT";
    const email = "customer@example.com";
    const firstname = "John";
    const productinfo = "Travel Booking";

    const hashRes = await axios.post('http://localhost:5000/generate_hash', {
      key,
      txnid,
      amount,
      productinfo,
      firstname,
      email,
      salt,
    });

    setPaymentData({
      key,
      txnid,
      amount,
      productinfo,
      firstname,
      email,
      phone: "9999999999",
      surl: "https://yourapp.com/success",
      furl: "https://yourapp.com/failure",
      hash: hashRes.data.hash,
      service_provider: "payu_paisa"
    });
  };

  return (
    <>
      <button  className="bg-gray-900 text-white px-4 py-2 rounded">
        Pay with PayU
      </button>

      {paymentData && (
        <form action="https://secure.payu.in/_payment" method="post">
          {Object.entries(paymentData).map(([key, value]) => (
            <input key={key} type="hidden" name={key} value={value} />
          ))}
          <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded mt-4">
            Proceed to Pay
          </button>
        </form>
      )}
    </>
  );
};

export default PayUButton;
